import { StateCreator } from "zustand";

export interface PartnerSlice {
  businessPartnerId: number | null;
  contactEmployeeId: number | null;
  setBusinessPartnerId: (id: number | null) => void;
  setContactEmployeeId: (id: number | null) => void;
  resetPartner: () => void;
}

export const createPartnerSlice: StateCreator<PartnerSlice> = (set) => ({
  businessPartnerId: null,
  contactEmployeeId: null,
  setBusinessPartnerId: (id) => set({ businessPartnerId: id }),
  setContactEmployeeId: (id) => set({ contactEmployeeId: id }),
  resetPartner: () => set({ businessPartnerId: null, contactEmployeeId: null }),
});
